import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';
export const Edit = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();
	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M37.9545 2.24934L39.7569 4.06522C41.4144 5.73516 41.4144 8.44576 39.7569 10.1157L13.7728 36.2949C13.6814 36.3384 13.5512 36.4 13.387 36.477C13.0402 36.6397 12.5424 36.8708 11.9403 37.1438C10.7348 37.6903 9.11659 38.4021 7.45712 39.0673C5.79034 39.7355 4.11255 40.3444 2.77885 40.6963C2.10713 40.8736 1.56717 40.9734 1.17974 40.9955C1.11025 40.9994 1.05063 41.0005 1.00006 40.9998C1.00041 40.9526 1.00257 40.8974 1.00738 40.8336C1.03605 40.4531 1.14562 39.9222 1.33597 39.2607C1.71382 37.9477 2.35694 36.2979 3.06017 34.6591C3.76023 33.0278 4.50655 31.438 5.079 30.2539C5.36493 29.6625 5.60684 29.1736 5.77702 28.8331C5.86181 28.6634 5.92876 28.5307 5.97443 28.4405L31.9703 2.24935C33.6236 0.583552 36.3012 0.58355 37.9545 2.24934ZM0.787591 40.9776C0.787655 40.9776 0.789257 40.978 0.792205 40.9791C0.788999 40.9782 0.787526 40.9777 0.787591 40.9776ZM1.01618 41.2076C1.01712 41.2104 1.01751 41.2118 1.01747 41.2119C1.01742 41.212 1.01695 41.2106 1.01618 41.2076Z'
				stroke={color ? handleColorType(color, theme) : '#00FFC2'}
				strokeWidth='2'
			/>
		</svg>
	);
};
